/**
 * Legacy localStorage key for the TPA Stream connect JWT.
 * SEC-LOW-01: token is memory-only; this key is only removed for cleanup.
 * checkov:skip=CKV_SECRET_6: storage key name, not a secret value
 */
export const TPA_STREAM_CONNECT_TOKEN_STORAGE_KEY = 'tpaStreamConnectToken';
